import React from "react";
import "../css/Contact.css";

const Contact = () => {
  return (
    <div className="contact6">

      {/* ================= HERO ================= */}
      <section className="c6-hero">
        <h1>Visit the Studio</h1>
        <p>Movement begins with showing up.</p>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="c6-content">

        {/* LEFT — INFO */}
        <div className="c6-info">

          <div className="info-block">
            <h3>Location</h3>
            <p>
              Earthfit Studio<br />
              214 Greenway Avenue<br />
              Portland, OR 97204
            </p>
          </div>

          <div className="info-block">
            <h3>Hours</h3>
            <p>
              Monday – Friday: 6:00 AM – 10:00 PM<br />
              Saturday: 8:00 AM – 6:00 PM<br />
              Sunday: Closed
            </p>
          </div>

          <div className="info-block">
            <h3>Contact</h3>
            <p>
              Phone: +1 800 244 9023<br />
              Email: hello@earthfit.studio
            </p>
          </div>

        </div>

        {/* RIGHT — MAP */}
        <div className="c6-map">
          <iframe
            title="Earthfit Location"
            src="https://maps.google.com/maps?q=Portland%20Oregon&t=&z=13&ie=UTF8&iwloc=&output=embed"
            loading="lazy"
          ></iframe>
        </div>

      </section>

      {/* ================= FOOT NOTE ================= */}
      <section className="c6-note">
        <p>
          Walk in. Breathe. Move with intention.
        </p>
      </section>

    </div>
  );
};

export default Contact;
